// extracted by mini-css-extract-plugin
export default {"overlayContainer":"WorkbookIframePortal__overlayContainer___Be5w0"};